import React, { useState } from "react";
import "./Faq.css"; // reuse same styling
import axios from "axios";
import { message } from "antd";

const NyeFaq = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    package: "",
    message: "",
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send data to backend (adjust the URL to match your API endpoint)
      const response = await axios.post("api/inquiry/add-inquiry", {
        name: formData.name,
        phone: formData.phone,
        package: formData.package,
        message: formData.message,
      });

      // Handle response
      if (response.data.success) {
        message.success(response.data.message);
        // Reset form
        setFormData({
          name: "",
          phone: "",
          package: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("There was an error. Please try again.");
    }
  };
  return (
    <div className="faq-container Mon_font">
      <h2 className="faq">NYE Trips - Frequently Asked Questions</h2>
      
      <div className="faq-content">
        <div className="faq-questions">
          <div className="accordion" id="accordionNyeExample">
            
            {/* FAQ 1 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseOne"
                  aria-expanded="false"
                  aria-controls="nye-collapseOne"
                >
 What makes High Mountains’ New Year Trips special?                </button>
              </h2>
              <div
                id="nye-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingOne"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Our NYE trips aren’t regular vacations — they’re full-blown experiences. Think sunset yacht parties, snow adventures, beach countdowns, and new friendships that feel like family. Every trip is designed for young, energetic travellers who love good vibes, music, and memories.                </div>
              </div>
            </div>

            {/* FAQ 2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseTwo"
                  aria-expanded="false"
                  aria-controls="nye-collapseTwo"
                >
What is the ASG Special?                </button>
              </h2>
              <div
                id="nye-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingTwo"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
ASG Special stands for Aman Singh Gulati Special — our signature, limited-seat departure curated personally by our founder. Expect exclusive parties, extra surprises, and a crazy fun tribe that defines what High Mountains is all about.                </div>
              </div>
            </div>

            {/* FAQ 3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseThree"
                  aria-expanded="false"
                  aria-controls="nye-collapseThree"
                >
                 Which New Year destinations can I choose from?
                </button>
              </h2>
              <div
                id="nye-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingThree"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Celebrate the New Year your way — from the snowy magic of Kashmir and Ladakh, to the tropical energy of Bali (Pre-NYE) and Thailand (Phuket & Koh Samui), or the island fun of the Philippines. You can also plan custom NYE trips to destinations like Dubai, Greece, or Kenya — anywhere your party soul takes you.                </div>
              </div>
            </div>

              {/* FAQ 4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseFour"
                  aria-expanded="false"
                  aria-controls="nye-collapseFour"
                >
Can I join solo?                </button>
              </h2>
              <div
                id="nye-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingFour"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Of course! Most of our travellers come solo — you’ll instantly connect with a like-minded tribe who love travel, parties, and spontaneous adventures. Solo today, squad tomorrow!                </div>
              </div>
            </div>
  {/* FAQ 5*/}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseFive"
                  aria-expanded="false"
                  aria-controls="nye-collapseFive"
                >
Are flights and visas included?                </button>
              </h2>
              <div
                id="nye-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingFive"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Flights are usually excluded so you can fly from anywhere in India. Visas are separate, but don’t worry — our team will guide and assist you through the visa process step by step                </div>
              </div>
            </div>
  {/* FAQ 6*/}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingSix">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseSix"
                  aria-expanded="false"
                  aria-controls="nye-collapseSix"
                >
What kind of crowd joins these trips?                </button>
              </h2>
              <div
                id="nye-collapseSix"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingSix"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
These are party groups — filled with young, energetic, and social travellers aged 20–35 who love to dance, celebrate, and make the most of every night.
 If you’re not into parties or nightlife, these may not be the right trips for you. We keep the energy high and the vibes unmatched!                </div>
              </div>
            </div>
  {/* FAQ 7 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingSeven">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseSeven"
                  aria-expanded="false"
                  aria-controls="nye-collapseSeven"
                >
Is it safe for solo girls?                </button>
              </h2>
              <div
                id="nye-collapseSeven"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingSeven"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Absolutely. Our trips are led by professional tour captains, verified local partners, and stay in trusted accommodations. The group always moves together, and we make sure everyone feels safe, respected, and included at all times.
                </div>
              </div>
            </div>
  {/* FAQ 8 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingEight">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseEight"
                  aria-expanded="false"
                  aria-controls="nye-collapseEight"
                >
What’s the accommodation like?                </button>
              </h2>
              <div
                id="nye-collapseEight"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingEight"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
We choose stays that are clean, comfortable, and perfectly located — from cozy boutique hotels in Kashmir to pool-view resorts in Koh Samui. Always social, stylish, and perfect for chilling or pre-partying with your tribe.                </div>
              </div>
            </div>
  {/* FAQ 9 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingNine">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseNine"
                  aria-expanded="false"
                  aria-controls="nye-collapseNine"
                >
What’s your cancellation policy?                </button>
              </h2>
              <div
                id="nye-collapseNine"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingNine"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Your booking amount is non-refundable. If you cancel 45+ days before, 10% of the trip cost is charged; 30–45 days: 25%; 15–30 days: 50%; within 15 days: 100%. Check our Cancellation Policy page for full details before booking.                </div>
              </div>
            </div>
  {/* FAQ 10 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingTen">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseTen"
                  aria-expanded="false"
                  aria-controls="nye-collapseTen"
                >
Can I customize my own New Year trip?                </button>
              </h2>
              <div
                id="nye-collapseTen"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingTen"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Yes! Want a private NYE celebration with your own gang? We create custom experiences across the globe — from luxury villas in Bali to mountain cabins or beach resorts. Tell us your dream plan, and we’ll make it happen.                </div>
              </div>
            </div>
  {/* FAQ 11 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingEleven">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseEleven"
                  aria-expanded="false"
                  aria-controls="nye-collapseEleven"
                >
How many people are there in a group?                </button>
              </h2>
              <div
                id="nye-collapseEleven"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingEleven"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Our groups usually have around 20 travellers — big enough for great energy, small enough to feel like family. Every trip has a tour captain and local coordinators to make sure everything runs smoothly.                </div>
              </div>
            </div>
  {/* FAQ 12 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingTwelve">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseTwelve"
                  aria-expanded="false"
                  aria-controls="nye-collapseTwelve"
                >
 What’s included in the trip cost?                </button>
              </h2>
              <div
                id="nye-collapseTwelve"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingTwelve"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Every NYE package includes stays, daily breakfast, local transfers, sightseeing, parties, and experiences as mentioned in the itinerary. Flights, visas, and personal expenses are separate. (Check inclusions on each trip page for exact details.                </div>
              </div>
            </div>
  {/* FAQ 13 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="nye-headingThirteen">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#nye-collapseThirteen"
                  aria-expanded="false"
                  aria-controls="nye-collapseThirteen"
                >
 When do bookings usually close?                 </button>
              </h2>
              <div
                id="nye-collapseThirteen"
                className="accordion-collapse collapse"
                aria-labelledby="nye-headingThirteen"
                data-bs-parent="#accordionNyeExample"
              >
                <div className="accordion-body">
Our NYE trips sell out fast, especially Thailand and Bali. We recommend booking at least 45–60 days in advance to secure your seat — once it’s sold out, it’s really gone.                </div>
              </div>
            </div>

          </div>
        </div>

        
           <div className="faq-contact">
          <h3>Got Any Questions?</h3>
          <p>You can ask about anything related to NYE Trips</p>
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              {/* Name Field */}
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              {/* Phone Number Field */}
              <input
                type="tel"
                className="form-control"
                placeholder="Enter Your Phone Number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              {/* Package Field */}
              <input
                type="text"
                className="form-control"
                placeholder="Enter the Package You're Interested In"
                name="package"
                value={formData.package}
                onChange={handleChange}
                required
              />

              {/* Message Field */}
              <textarea
                className="form-control"
                placeholder="Your Question (Optional)"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              {/* Submit Button */}
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NyeFaq;
